import { useAuth } from '@/features/authentication/hooks/useAuth';
import { loggingUtility } from '@/utils/loggingUtility';
import { buildMarketingUrl } from '@/utils/subdomainUtils';
import { ProgressSpinner } from 'primereact/progressspinner';
import React, { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

const AuthCallbackPage: React.FC = () => {
  const { t } = useTranslation();
  const { login } = useAuth();
  const navigate = useNavigate();
  const isProcessingRef = useRef(false);

  useEffect(() => {
    const processCallback = () => {
      if (isProcessingRef.current) {
        return;
      }
      isProcessingRef.current = true;

      try {
        const params = new URLSearchParams(window.location.search);
        const organizationsParam = params.get('organizations');
        const returnUrl = params.get('returnUrl');

        const organizations = organizationsParam
          ? JSON.parse(organizationsParam)
          : [];

        login({
          organizations,
        });

        // If no returnUrl provided by backend, redirect to marketing site
        if (!returnUrl) {
          const marketingUrl = buildMarketingUrl();
          window.location.href = marketingUrl;
          return;
        }

        navigate(returnUrl, { replace: true });
      } catch (error) {
        loggingUtility.error('Failed to process callback:', error);
        const marketingUrl = buildMarketingUrl();
        window.location.href = marketingUrl;
      }
    };

    processCallback();
  }, [login, navigate]);

  return (
    <div className='flex flex-col justify-center items-center min-h-[400px] gap-4'>
      <ProgressSpinner />
      <p className='text-center'>{t('auth.completingAuthentication')}</p>
    </div>
  );
};

export default AuthCallbackPage;
